import Emails from './Emails.component';

export default { Emails };
